const itemNoIndexConstruct = (oldItems, newItems) => {
  if (oldItems?.length > 1) return newItems;
  else if (
    oldItems?.length === 1 &&
    (oldItems?.[0]?.index || oldItems?.[0]?.index === 0)
  )
    return oldItems;
  else if (oldItems?.length === 1 && !oldItems?.[0]?.index) return newItems;
  else return oldItems;
};

const returnedRowsX = (rows) => {
  // set home and away tags
  const mappedReturnedRows = rows
    ?.filter((x) => x?.colType !== "teams")
    .map((x) => {
      const items = x?.items?.map((item, i) => {
        return {
          ...item,
          index: i,
        };
      });

      return {
        ...x,
        // items,
        items: itemNoIndexConstruct(x?.items, items),
      };
    });

  const mappedTeams = rows?.filter((x) => x?.colType === "teams");
  // console.log({ mappedTeams, mappedReturnedRows });
  return [...mappedTeams, ...mappedReturnedRows];
};

export function createGuidId() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// a little function to help us with reordering the result
export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const reorderRows = ({
  rows,
  destination,
  source,
  draggableId,
  mode,
  reason,
  type,
  combine,
}) => {
  console.log({
    rows,
    destination,
    source,
    draggableId,
    mode,
    reason,
    type,
    combine,
  });
  if (type === "row") {
    console.log("hit row");

    const sourceIdentifier = source.droppableId.split("/")[1];
    const destinationIdentifier = destination.droppableId.split("/")[1];

    // use only index to replace item
    let sourceI = source?.index;
    let destinationI = destination?.index;

    // fix bug with destination index longer than destination total items length
    const matches = Object.entries(
      groupBy(
        rows.filter((r) => r.colType === "matches"),
        "identifier"
      )
    );

    // console.log({ destinationIdentifier, matches });

    const findIndentifierArrayLength = matches?.find(
      ([key, value]) => key === destinationIdentifier
    )?.[1]?.length;

    if (destinationI > findIndentifierArrayLength - 1) {
      destinationI = destinationI - 1;
    }
    const onlyMatches = rows.filter((x) => x?.colType === "matches");

    const findSourceItem = matches?.find(
      ([key, value], index) => key === sourceIdentifier
    )?.[1][sourceI];

    const findDestinationItem = matches?.find(
      ([key, value], index) => key === destinationIdentifier
    )?.[1][destinationI];

    const indexOffindSourceItem = onlyMatches.indexOf(findSourceItem);
    const indexOffindDestinationItem = onlyMatches.indexOf(findDestinationItem);

    if (indexOffindSourceItem < indexOffindDestinationItem) {
      alert(
        "Limitation: Cannot drag from top to bottom, please drag from bottom to top"
      );
      return rows;
    }

    const newRows = [...onlyMatches];

    console.log(findSourceItem?.time, findDestinationItem?.time);
    newRows[indexOffindSourceItem] = {
      ...findDestinationItem,
      identifier: findSourceItem?.identifier,
      // time: findSourceItem?.time,
    };
    newRows[indexOffindDestinationItem] = {
      ...findSourceItem,
      identifier: findDestinationItem?.identifier,
      // time: findDestinationItem?.time,
    };

    console.log({ newRows });

    // return rows;
    return [rows?.[0], ...newRows];
  }

  console.log("hit here");
  const current = rows.find((x) => x.id === source.droppableId);
  const next = rows.find((x) => x.id === destination.droppableId);
  const target = current.items[source.index];

  // moving to same list
  const isMovingToSameList = source.droppableId === destination.droppableId;
  const isMovingAlreadyExistingItemToList = next.items.some(
    ({ id }) => id === target.id
  );

  if (
    isMovingAlreadyExistingItemToList &&
    source.droppableId !== destination.droppableId
  ) {
    const currentItem = current.items[source?.index]?.name;
    alert(`Item ${currentItem} already exist in destination list`);
    return rows;
  }

  if (isMovingToSameList || isMovingAlreadyExistingItemToList) {
    const reordered = reorder(current.items, source.index, destination.index);

    const newRows = rows.map((x) =>
      x.id === source.droppableId
        ? {
            ...x,
            items: reordered,
          }
        : x
    );

    return returnedRowsX(newRows);
  }

  console.log("hit there");
  if (next.items.length >= 2) {
    const indexOfCurrent = rows.indexOf(current);
    const indexOfNext = rows.indexOf(next);

    const currentItems = [...current.items];
    const nextItems = [...next.items];

    //destination index cannot be longer than destination items length
    const destIndex =
      destination.index > next.items.length - 1
        ? next.items.length - 1
        : destination.index;

    //make sure swapped item does not already exist in desination items
    const nextItem = next.items[destIndex];

    // item already exists in list
    if (source.droppableId !== "teams") {
      if (
        current.items.some(
          (i) => i.id === nextItem.id && i.name === nextItem.name
        )
      ) {
        alert(`Cannot swap, ${nextItem.name} already exists in source list`);
        return rows;
      }
    }
    //swap items
    nextItems.splice(destIndex, 1, current.items[source.index]);
    currentItems.splice(source.index, 1, next.items[destIndex]);

    const newRows = [...rows];

    //dont duplicate in teams
    if (source.droppableId !== "teams") {
      newRows[indexOfCurrent] = {
        ...current,
        items: currentItems,
      };
    }

    newRows[indexOfNext] = {
      ...next,
      items: nextItems,
    };

    // return newRows;
    return returnedRowsX(newRows);
  }

  console.log("hit there 2");
  // moving to different list

  // remove from original
  if (source.droppableId !== "teams") {
    current.items.splice(source.index, 1);
  }
  // insert into next
  next.items.splice(destination.index, 0, target);

  const newRows = rows.map((x) => {
    if (x.id === source.droppableId) {
      return {
        ...x,
        items: current.items,
      };
    } else if (x.id === destination.droppableId) {
      return {
        ...x,
        items: next.items,
      };
    }

    return x;
  });

  return returnedRowsX(newRows);
};

export const groupBy = (items, key) =>
  items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {}
  );

export const formatDataToSend = (newRows) => {
  const teams = newRows
    .find((r) => r.colType === "teams")
    .items.map((t) => t?.id);

  const matches = Object.entries(
    groupBy(
      newRows.filter((r) => r.colType === "matches"),
      "identifier"
    )
  );

  const matchdays = matches.map(([key, value]) => {
    const matches = value.map((match, i) => {
      const teamsObj = match.items.reduce((acc, val) => {
        return {
          ...acc,
          [val?.index === 0 ? "home" : "away"]: val?.id || "",
        };
      }, {});

      return {
        ...teamsObj,
        datetime: match.time,
      };
    });

    return {
      date: key?.split("*")?.[0],
      matches,
    };
  });

  const newData = {
    teams,
    matchdays,
  };
  return newData;
};

export const localISOTime = (date) => {
  return new Date(
    date.getTime() - date.getTimezoneOffset() * 60000
  ).toISOString();
};
